/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free_trial_day: NonNullable<unknown> }} Tag_Trial_DayInputs */

const en_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} Days Free`)
};

const ar_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} أيام مجاناً`)
};

const de_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} Tage kostenlos`)
};

const es_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} días gratis`)
};

const fr_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} jours gratuits`)
};

const it_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} giorni gratis`)
};

const ja_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day}日間無料`)
};

const ko_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day}일 무료`)
};

const pt_br_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} dias grátis`)
};

const ru_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} дней бесплатно`)
};

const th_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ฟรี ${i?.free_trial_day} วัน`)
};

const tr_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} gün ücretsiz`)
};

const zh_cn_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} 天免费`)
};

const zh_tw_tag_trial_day = /** @type {(inputs: Tag_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} 天免費`)
};

/**
* | output |
* | --- |
* | "{free_trial_day} Days Free" |
*
* @param {Tag_Trial_DayInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tag_trial_day = /** @type {((inputs: Tag_Trial_DayInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tag_Trial_DayInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tag_trial_day(inputs)
	if (locale === "ar") return ar_tag_trial_day(inputs)
	if (locale === "de") return de_tag_trial_day(inputs)
	if (locale === "es") return es_tag_trial_day(inputs)
	if (locale === "fr") return fr_tag_trial_day(inputs)
	if (locale === "it") return it_tag_trial_day(inputs)
	if (locale === "ja") return ja_tag_trial_day(inputs)
	if (locale === "ko") return ko_tag_trial_day(inputs)
	if (locale === "pt_br") return pt_br_tag_trial_day(inputs)
	if (locale === "ru") return ru_tag_trial_day(inputs)
	if (locale === "th") return th_tag_trial_day(inputs)
	if (locale === "tr") return tr_tag_trial_day(inputs)
	if (locale === "zh_cn") return zh_cn_tag_trial_day(inputs)
	return zh_tw_tag_trial_day(inputs)
});